import { VpArrowRightDownIcon, VpArrowRightUpIcon } from '@vtmn-play/icons/react'

interface ProductivityIconProps {
  targetProductivity: number
  productivity: number
}

const ProductivityIcon = ({ targetProductivity, productivity }: ProductivityIconProps) => {
  if (productivity < targetProductivity) {
    return (
      <div data-testid="productivity-icon" className="mg-productivity-icon mg-productivity-icon__negative">
        <VpArrowRightDownIcon />
      </div>
    )
  }
  return (
    <div data-testid="productivity-icon" className="mg-productivity-icon mg-productivity-icon__positive">
      <VpArrowRightUpIcon />
    </div>
  )
}

export default ProductivityIcon
